import {
  GridRowModes,
  GridRowModesModel,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import ActionButtons from "../ActionUserButtons";
import { handleSendMessage, syncItems } from "src/utilities";
import { UseMutateAsyncFunction } from "@tanstack/react-query";
import AddIcon from "@mui/icons-material/Add";

import { useNotifications } from "@toolpad/core/useNotifications";
import { IAppUser } from "src/interface/IUser";
import { TypeUser } from "src/interface/enum/TypeUser";
import { Box, Button, Stack } from "@mui/material";

interface EditToolbarRelatedUserProps {
  userRef?: string;
  updatingRelatedUser?: IAppUser[];
  setUpdatingRelatedUser?: (updatingRelatedUser: IAppUser[]) => void;
  existingRelatedUser?: IAppUser[];
  deletedUserAsync: UseMutateAsyncFunction<any, Error, any, unknown>;
  deleteLoading: boolean;
  insertAsync: UseMutateAsyncFunction<any, Error, any, unknown>;
  insertLoading: boolean;
  updateAsync: UseMutateAsyncFunction<any, Error, any, unknown>;
  updateLoading: boolean;
  userData?: IAppUser;
  setRows: (newRows: (oldRows: IAppUser[]) => IAppUser[]) => void;
  setRowModesModel: (
    newModel: (oldModel: GridRowModesModel) => GridRowModesModel
  ) => void;

  onClose: () => void;
  rows: IAppUser[];
}

export function EditToolbarRelatedUser({
  userRef,
  updatingRelatedUser,
  existingRelatedUser,
  deletedUserAsync,
  insertAsync,
  updateAsync,
  deleteLoading,
  insertLoading,
  updateLoading,
  userData,
  rows,
  setRowModesModel,
  setRows,
  onClose,
  setUpdatingRelatedUser,
}: EditToolbarRelatedUserProps) {
  const handleClick = () => {
    const userID = rows ? rows.length + 1 : 1; // ایجاد یک شناسه منحصر به فرد برای ردیف جدید
    const newRow: IAppUser = {
      id: userID.toString(),
      roleTitle: "",
      fName: "",
      lName: "",
      phoneNumber: "",
      telNumber: "",
      isActive: true,
      isNew: true, // نشان‌دهنده ردیف جدید
    };

    setRows((oldRows) => [...(oldRows || ([] as IAppUser[])), newRow]);

    setRowModesModel((oldModel) => ({
      ...oldModel,
      [userID]: { mode: GridRowModes.Edit, fieldToFocus: "itemRef" },
    }));
  };
  const notifications = useNotifications();

  const onSave = async () => {
    if (
      (existingRelatedUser?.length === 0 || !existingRelatedUser) &&
      updatingRelatedUser?.length === 0
    ) {
      handleSendMessage(
        notifications,
        "هیچ کاربری برای ذخیره سازی وجود ندارد",
        "error",
        3000,
        "error"
      );
      return;
    }
    try {
      console.log("🚀 ~ onSave ~ userRef:", userRef);

      await syncItems<IAppUser>({
        deleteItemAsync: deletedUserAsync,
        existingItems: existingRelatedUser,
        insertItemAsync: insertAsync,
        isEdit: true,
        RefField: "parentRef",
        RefValue: userRef,
        updatedItems:
          updatingRelatedUser?.map((row: any) => {
            const randomThreeDigit = Math.floor(100 + Math.random() * 9000);
            return {
              ...row,
              ParentRef: userRef,
              userName: (userData?.phoneNumber ?? "") + randomThreeDigit,
              nationalCode: (userData?.phoneNumber ?? "") + randomThreeDigit,
              roleName: TypeUser.CUSTOMER,
            };
          }) || [],
        updateItemAsync: updateAsync,
      });
    } catch (error) {
      console.error("خطا در همگام‌سازی کلی:", error);
      notifications.show("خطا در عملیات همگام‌سازی افراد مرتبط!", {
        severity: "error",
        autoHideDuration: 5000,
      });
    }
  };
  const onSaveAndClose = async () => {
    await onSave(); // منتظر تکمیل onSave
    setUpdatingRelatedUser && setUpdatingRelatedUser([]);
    onClose(); //
  };
  return (
    <GridToolbarContainer>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        sx={{ padding: 1 }}
      >
        <Box>
          <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
            رابط جدید
          </Button>
        </Box>
        <ActionButtons
          onSave={onSave}
          onSaveAndClose={onSaveAndClose}
          isLoading={deleteLoading || insertLoading || updateLoading}
        />
      </Stack>
    </GridToolbarContainer>
  );
}
